import PropTypes from 'prop-types';

const classesShape = PropTypes.object;

export { classesShape };
